import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycby5lZl8jSG7TTKWSbuNN4exJzdY4b0AHUeyq1eZT2t6qYw0PwSidbTUsUNe1vZ10PpNjA/exec";

export default function Landing() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ username: "", city: "", email: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    if (formData.username && formData.email) {
      try {
        await fetch(GOOGLE_SCRIPT_URL, {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
      } catch (error) {
        console.error("Failed to send data to Google Sheets", error);
      }
    }
    
    setLoading(false);
    navigate("/play");
  };
  return (
    <div
      data-testid="landing-root"
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(ellipse at top right, #2d1b4e 0%, #0a0a14 50%, #02030a 100%)",
        color: "#fff",
        fontFamily: "'Inter', system-ui, sans-serif",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Decorative grid */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
          maskImage:
            "radial-gradient(ellipse at center, black 30%, transparent 80%)",
        }}
      />

      {/* Nav */}
      <nav
        style={{
          position: "relative",
          padding: "22px 40px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          zIndex: 2,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              background:
                "linear-gradient(135deg, #ffd23f 0%, #ff4d6d 50%, #e879f9 100%)",
            }}
          />
          <div>
            <div style={{ fontSize: 16, fontWeight: 800, letterSpacing: 1 }}>
              PRAYOGASHAALA
            </div>
            <div
              style={{
                fontSize: 10,
                color: "#9aa4b2",
                letterSpacing: 3,
                marginTop: -2,
              }}
            >
              PHYSICS · GAMIFIED
            </div>
          </div>
        </div>
        <Link
          to="/play"
          data-testid="nav-play-btn"
          style={{
            padding: "10px 22px",
            background: "rgba(255,255,255,0.06)",
            border: "1px solid rgba(255,255,255,0.15)",
            borderRadius: 100,
            color: "#fff",
            textDecoration: "none",
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          Play →
        </Link>
      </nav>

      {/* Hero */}
      <section
        style={{
          position: "relative",
          padding: "60px 40px 30px",
          maxWidth: 1100,
          margin: "0 auto",
          zIndex: 2,
        }}
      >
        <div
          style={{
            fontSize: 13,
            letterSpacing: 5,
            color: "#e879f9",
            fontWeight: 600,
            marginBottom: 14,
          }}
        >
          PHYSICS TRAINING VALLEY
        </div>
        <h1
          style={{
            fontSize: "clamp(36px, 6vw, 64px)",
            fontWeight: 900,
            lineHeight: 1.1,
            letterSpacing: -1.5,
            margin: 0,
            maxWidth: 900,
          }}
        >
          Welcome to{" "}
          <span
            style={{
              background:
                "linear-gradient(90deg, #ffd23f 0%, #ff4d6d 50%, #e879f9 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Phase 1
          </span>{" "}
          of the Play!
        </h1>
        <div
          style={{
            color: "#9aa4b2",
            fontSize: 16,
            lineHeight: 1.6,
            maxWidth: 640,
            marginTop: 22,
          }}
        >
          <p>
            Experience kinematics and Newtonian mechanics in a massive interactive world. 
            <strong> As new phases are developed and uploaded, you will receive an email notification.</strong>
          </p>
          <p style={{ marginTop: 10, padding: 12, background: "rgba(255,255,255,0.05)", borderRadius: 8, border: "1px solid rgba(255,255,255,0.1)" }}>
            🎓 <strong>Preparing for IBDP Physics?</strong><br />
            Check out the author's <a href="https://www.youtube.com/@IBPhysicsWithRao" target="_blank" rel="noreferrer" style={{ color: "#00ffaa" }}>YouTube channel</a> to view comprehensive video guides and tutorials to help you ace your exams!
          </p>
        </div>

        <div style={{ marginTop: 36, maxWidth: 400, background: "rgba(255,255,255,0.03)", padding: 24, borderRadius: 16, border: "1px solid rgba(255,255,255,0.1)" }}>
          <h3 style={{ margin: "0 0 20px", color: "#fff", fontSize: 20 }}>Register to Play</h3>
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <input 
              type="text" 
              placeholder="Username" 
              required
              value={formData.username}
              onChange={e => setFormData({...formData, username: e.target.value})}
              style={{ padding: "14px 16px", borderRadius: 10, border: "none", background: "rgba(255,255,255,0.1)", color: "#fff", fontSize: 16 }}
            />
            <input 
              type="text" 
              placeholder="City" 
              value={formData.city}
              onChange={e => setFormData({...formData, city: e.target.value})}
              style={{ padding: "14px 16px", borderRadius: 10, border: "none", background: "rgba(255,255,255,0.1)", color: "#fff", fontSize: 16 }}
            />
            <input 
              type="email" 
              placeholder="Email ID" 
              required
              value={formData.email}
              onChange={e => setFormData({...formData, email: e.target.value})}
              style={{ padding: "14px 16px", borderRadius: 10, border: "none", background: "rgba(255,255,255,0.1)", color: "#fff", fontSize: 16 }}
            />
            <button
              type="submit"
              disabled={loading}
              style={{
                marginTop: 10,
                padding: "16px 20px",
                background: "linear-gradient(135deg, #00ffaa 0%, #3eb6ff 100%)",
                color: "#0a0a14",
                border: "none",
                borderRadius: 10,
                fontSize: 18,
                fontWeight: 800,
                cursor: loading ? "wait" : "pointer",
                boxShadow: "0 10px 30px rgba(0, 255, 170, 0.3)",
              }}
            >
              {loading ? "Registering..." : "Enter the Valley ▶"}
            </button>
          </form>
        </div>
      </section>

      {/* Features */}
      <section
        id="features"
        style={{
          position: "relative",
          padding: "60px 40px 80px",
          maxWidth: 1100,
          margin: "0 auto",
          zIndex: 2,
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: 18,
          }}
        >
          {[
            {
              tag: "TRACK",
              title: "Newton's Laws + Friction",
              body: "3D Catmull-Rom track with hills, valleys, and a jump gap. Switch friction coefficient μ: ice, standard or gravel.",
              color: "#00ffaa",
            },
            {
              tag: "AIR",
              title: "Projectile + Air Resistance",
              body: "Jump or fly off. Parachute drag scales with surface area: F = ½ρCdAv². Reach terminal velocity safely.",
              color: "#ffd23f",
            },
            {
              tag: "WATER",
              title: "Buoyancy & Upthrust",
              body: "Land in water — buoyant force Fb = ρVg vs gravity. Upthrust to swim up, reach shore.",
              color: "#3eb6ff",
            },
            {
              tag: "LEARN",
              title: "Fill-in-the-blank Recap",
              body: "Fall off the track? Get a physics question with the exact equation. Answer correctly to resume without losing coins.",
              color: "#e879f9",
            },
            {
              tag: "PHASES",
              title: "Physics Park: phase by phase",
              body: "Phase 1: Circular Motion. Phase 2: SUVAT & Energy. Certify each ride, earn your Engineer's License stamp by stamp.",
              color: "#ff4d6d",
            },
            {
              tag: "COINS",
              title: "Economy & Rewards",
              body: "Start with 50 coins. Earn at stations. Pay 30 for parachute, 50 for jump. Avoid penalties by playing smart.",
              color: "#ffd23f",
            },
          ].map((f, i) => (
            <div
              key={i}
              data-testid={`feature-card-${i}`}
              style={{
                padding: 22,
                background: "rgba(255,255,255,0.03)",
                border: "1px solid rgba(255,255,255,0.08)",
                borderRadius: 18,
              }}
            >
              <div
                style={{
                  fontSize: 10,
                  letterSpacing: 3,
                  color: f.color,
                  fontWeight: 700,
                }}
              >
                {f.tag}
              </div>
              <div
                style={{ fontSize: 18, fontWeight: 700, margin: "8px 0 10px" }}
              >
                {f.title}
              </div>
              <div style={{ color: "#9aa4b2", fontSize: 14, lineHeight: 1.6 }}>
                {f.body}
              </div>
            </div>
          ))}
        </div>
      </section>

      <footer
        style={{
          position: "relative",
          padding: "30px 40px 40px",
          textAlign: "center",
          color: "#5a6478",
          fontSize: 13,
          zIndex: 2,
        }}
      >
        © {new Date().getFullYear()} Prayogashaala · Built for physics teachers
        and curious students.
      </footer>
    </div>
  );
}
